
                            Shopify.formatMoney = function(cents, format) {
                            if (typeof cents == 'string') {
                            cents = cents.replace('.', '');
                            }
                            var value = '';
                            var placeholderRegex = /{{\s*(\w+)\s*}}/;
                            var formatString = (format || this.money_format);
                            function defaultOption(opt, def) {
                                return (typeof opt == 'undefined' ? def : opt);
                            }
                            function formatWithDelimiters(number, precision, thousands, decimal) {
                                precision = defaultOption(precision, 2);
                                thousands = defaultOption(thousands, ',');
                                decimal = defaultOption(decimal, '.');
                                if (isNaN(number) || number == null) {
                                    return 0;
                                }
                                number = (number / 100.0).toFixed(precision);
                                var parts = number.split('.'),
                                    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                                    cents = parts[1] ? (decimal + parts[1]) : '';
                                return dollars + cents;
                            }
                            switch (formatString.match(placeholderRegex)[1]) {
                                case 'amount':
                                    value = formatWithDelimiters(cents, 2);
                                    break;
                                case 'amount_no_decimals':
                                    value = formatWithDelimiters(cents, 0);
                                    break;
                                case 'amount_with_comma_separator':
                                    value = formatWithDelimiters(cents, 2, '.', ',');
                                    break;
                                case 'amount_no_decimals_with_comma_separator':
                                    value = formatWithDelimiters(cents, 0, '.', ',');
                                    break;
                            }
                            return formatString.replace(placeholderRegex, value);
                            };



            function waitFor(selector, callback) {
            // Check immediately
            const element = document.querySelector(selector);

            if (element) {
                callback(element);
                return;
            }

            // Watch for future DOM changes
            const observer = new MutationObserver(() => {
                const element = document.querySelector(selector);

                if (element) {
                observer.disconnect();
                callback(element);
                }
            });

            observer.observe(document.documentElement, {
                childList: true,
                subtree: true
            });
            }

            //waitFor("#aov-threshold", ()=> {

                console.log("[AOV] Script loaded");

                const thresholdBase = window.thresholdBase;
                const elId = "aov-threshold";

                console.log("[AOV] Raw thresholdBase from Liquid:", thresholdBase);

                function roundUpTo100Minus5(value) {
                    const roundedUp = Math.ceil(value / 100) * 100;
                    const final = roundedUp - 5;

                    return final;
                }
                function render() {

                                const el = document.getElementById(elId);

                                if (!el) {
                                    console.warn("[AOV] ERROR: element not found:", elId);
                                    return;
                                }

                                const rate = Shopify.currency?.rate || 1;

                                //safety line for USD, uses liquid.
                                if (rate == 1) return;

                                //CAD price:
                                //AUD price:

                                const parsed = parseFloat(thresholdBase);
                            
                                if (isNaN(parsed)) {
                                    console.error("[AOV] ERROR: thresholdBase is NaN");
                                    return;
                                }

                                // convert base value, in cents
                                const converted = parsed * rate * 100;
                            
                                // apply custom rounding rule
                                const finalValue = roundUpTo100Minus5(converted);

                                const formatted = Shopify.formatMoney(finalValue);
                        
                                el.textContent = formatted;

                                console.log("[AOV] DOM updated");
                    }

                            render();

                            document.addEventListener("shopify:section:load", function () {
                                console.log("[pack banner] reload triggered");
                                render();
                            });

                                
                    

            //});